import { FlowBuilder } from "../../FlowBuilder";
import { FlowConfiguration } from "../../../rule-engine-core/Flow/FlowConfiguration";
import { RunExpression } from "../../../rule-engine-core/Flow/Steps/Expressions/RunExpression";
import { getDivideSimpleRule } from "../../../Expressions/Testing/MathData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

export const FlowBuilderExpressionStepStories = [
    new StoryNode(
        () => {
            let flow = new FlowConfiguration();
            flow.allSequences[0].addStep(new RunExpression());

            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "Designer",
        "Empty",
    ),
    new StoryNode(
        () => {
            let flow = new FlowConfiguration();
            let runExpression = new RunExpression();
            runExpression.expression = getDivideSimpleRule();
            flow.allSequences[0].addStep(runExpression);

            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "Designer",
        "Divide",
    ),
];
